import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';

function Header() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeNavbar = () => setExpanded(false);

  return (
    <Navbar 
      bg={scrolled ? "white" : "light"} 
      expand="lg" 
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
      className={`transition-all ${scrolled ? 'shadow-sm' : ''}`}
      style={{
        transition: 'all 0.3s ease-in-out',
        padding: scrolled ? '0.5rem 0' : '1rem 0'
      }}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img
            src="assets/images/vv_logo_new_25Apr.png"
            style={{ 
              width: '50px',
              height: 'auto',
              transition: 'all 0.3s ease-in-out'
            }}
            alt="VoteVocal"
            className="img-fluid"
          />
        </Navbar.Brand>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className="border-0"
          style={{ boxShadow: 'none !important' }}
        >
          <span className={`navbar-toggler-icon ${expanded ? 'open' : ''}`}></span>
        </Navbar.Toggle>
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link 
              as={Link} 
              to="/" 
              onClick={closeNavbar}
              className={`mx-2 px-3 py-2 ${location.pathname === '/' ? 'active-link' : ''}`}
            >
              Home
            </Nav.Link>
            
            {/* <Nav.Link 
              as={Link} 
              smooth 
              to="/#services" 
              onClick={closeNavbar}
              className="mx-2 px-3 py-2"
            >
              Services
            </Nav.Link> */}
            
            {/* <Button 
              as="a"
              href="/persons/steve_rao/index.html" 
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeNavbar}
              variant="outline-primary"
              className="ms-lg-2 mt-2 mt-lg-0 px-4 py-2"
              style={{
                borderRadius: '8px',
                fontWeight: '600',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                textDecoration: 'none'
              }}
            >
              Steve Rao Profile
            </Button> */}
            
            <Button 
              as={Link} 
              to="/admin" 
              onClick={closeNavbar}
              variant="primary"
              className="ms-lg-2 mt-2 mt-lg-0 px-4 py-2"
              style={{
                borderRadius: '8px',
                fontWeight: '600',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease'
              }}
            >
              Representative Login
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .navbar-toggler-icon {
          transition: all 0.3s ease;
          position: relative;
        }
        
        .navbar-toggler-icon.open {
          transform: rotate(90deg);
        }
        
        .active-link {
          color: #0d6efd !important;
          font-weight: 600;
          position: relative;
        }
        
        .active-link::after {
          content: '';
          position: absolute;
          bottom: 5px;
          left: 15px;
          width: calc(100% - 30px);
          height: 2px;
          background-color: #0d6efd;
          border-radius: 2px;
        }
        
        .nav-link {
          font-weight: 500;
          color: #495057 !important;
          transition: all 0.2s ease;
          border-radius: 8px;
        }
        
        .nav-link:hover {
          color: #0d6efd !important;
          background-color: rgba(13, 110, 253, 0.05);
        }
        
        @media (max-width: 991.98px) {
          .navbar-collapse {
            padding: 20px 0;
            background: white;
            margin-top: 15px;
            border-radius: 8px;
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
          }
          
          .nav-link {
            margin: 5px 0 !important;
          }
          
          .active-link::after {
            display: none;
          }
        }
      `}</style>
    </Navbar>
  );
}

export default Header;